<template>
    <div :class="[footerList.length == 0 ? 'd-none' : 'footerMenu']">
        <button
            v-for="(list, index) in footerList" :key="index"
            class="mypageframebutton px-1"
            @click="gotoPage(list.to)"
        >
            <div class="d-flex justify-content-center footerButtonDiv">
                <div class="mypage-footer-icon mt-2" :class="list.icon_class"/>
            </div>
            <div class="text-break mt-1" :class='[list.text_flag == 1 ? "footerTextSmall" : "footerText"]'>{{ list.footer_title }}</div>
        </button>
    </div>
</template>

<script>

import { GET_FOOTER_MENU } from '../../constants/mypage_top';
import { mapGetters } from 'vuex';

export default {
    data () {
        return {
            // フッター情報
            footerList: [],
            // 会員種別
            member_no: ''
        };
    },
    computed: {
        ...mapGetters('auth', [
            "loginMemberLineFlag"
        ])
    },
    watch: {
    },
    created () {
        this.initialize();
    },
    methods:{
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function () {
            this.member_no = this.$store.state.auth.loginMember.member_no;
            // メニュー取得
            this.footerList = await this.GetFooterMenuList(this.member_no);
        },
        /** ----------------------------------------------
         * メニュー情報取得
         * ---------------------------------------------- */
        async GetFooterMenuList(memberNo){
            this.$store.commit("loading/setIsLoading", true);
            let res = await this.$apollo.query({
                query: GET_FOOTER_MENU,
                variables: {
                    member_no: memberNo,
                    line_login_flag: this.loginMemberLineFlag
                }
            });

            this.footerList = res.data.GetFooterMenu.footerMenuList;
            this.$store.commit("loading/setIsLoading", false);
            this.$emit('footer-list', this.footerList);
            return this.footerList;
        },
        gotoPage(url) {
            let to = '';
            if (url === '/golf-course-list') {
                to = {name: 'GolfCourseLisst', params: {show: true}};
            } else {
                to = url;
            }
            this.$router.push(to);
        },
        logout () {
            this.$emit("out-click");
        }
    }
}
</script>

<style scoped>
.footerFont {
    font-size: 0.75rem;
    margin-top: 0.75rem;
}
.mypageframebutton {
    height: 70px;
    width: 100%;
    border-radius: 0;
}
.footerButtonDiv {
    height: 35px;
}
ul {
    list-style: none;
    padding: .5rem 0;
    display: flex;
    height: 100%;
    justify-content: space-around;
}

ul li {
    height: 100%;
    font-weight: 700;
    color: #fff !important;
    align-items: center;
    display: flex;
    font-size: .875rem;
    width: 100%;
    padding: 0 .25rem;
    justify-content: center;

}
.borderMore {
    border-right: 1px solid #fff;
}
.borderLast {
    border-right: none;
}
.footerText {
    font-size: clamp(10px, 2.5vw, 18px);
}
.footerTextSmall {
    font-size: clamp(9px, 2vw, 18px);
}
@media screen and (max-width: 575px) {
    .footerText,
    .footerTextSmall {
        font-weight: 700;
    }
}
</style>
